/**
 * Users service — activation status (deactivate / activate / inactive search).
 * Ported 1:1 from the legacy flat services/users.js; shapes verified against
 * docs/users-migration/Api-response/ (user-deactivate.json, user-activate.json).
 */
import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'
import {
  ChatApp,
  ActivateResponse,
  DeactivateResponse,
  UsersListResponse,
} from './types'

/** Deactivate — DELETE without a body (permanent delete is `crud.del`, same
 *  URL + `{permanent: true}` body). Response: `{data: {deactivatedUids}}`. */
export async function deactivate(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<DeactivateResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

/** Reactivate — PUT on the collection. Response: `{data: {reactivatedUids}}`. */
export async function activate(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<ActivateResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users`
  const post = { uidsToActivate: [id] }
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function inactiveSearch(
  app: ChatApp,
  apiHost: string,
  searchText: string,
  pageNo = 1,
): Promise<UsersListResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/users?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&onlyDeactivated=1&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}
